import "../../../../../css/AML/Buttons/SecondaryButton.css";

const SecondaryButton = ({ label, onClick, color, isDisabled, icon }) => {
  return (
    <div className="SecondaryButton" onClick={onClick} disabled={isDisabled}>
      {icon && <div>{icon}</div>}
      <div className="AML-Text-Input">{label}</div>
    </div>
  );
};

export default SecondaryButton;
